'use client';
import { makePersistenceHandles } from '@castlery/shared-persistence-kit';
import { isSupportedLocale } from '../settings';
import { Bcp47Locales } from '../types';
import { fallbackLocale } from '../settings';

export function getLocaleClient(): Bcp47Locales {
  const persistenceHandles = makePersistenceHandles({});
  const locale = persistenceHandles.preferredLanguage.getItem();
  if (locale && isSupportedLocale(locale)) {
    return locale as Bcp47Locales;
  }
  return fallbackLocale as Bcp47Locales;
}
